//src/config/config.js
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BASE_URL || 'http://localhost:8000',
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      LOGIN_GOOGLE: "/auth/login/google",
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh-token',
      CHECK: '/auth/check',
      CUSTOM_TOKEN: '/auth/custom-token',
      RESET_PASSWORD: '/auth/reset-password'
    },
    CREDITS: {
      HISTORY: '/credits/history',
      STATS: '/credits/stats',
      ADMIN_ADJUST: '/credits/admin/adjust',
      BONUS_ADD: '/credits/bonus/add',
      REFUND: '/credits/refund'
    },
    WORKFLOW: {
      GENERATE_TO_FOLDER: '/workflow/generate-to-folder',
      GENERATE_TO_FOLDER_LOT: '/workflow/generate-to-folder-lot',
      CHECK_STATUS: '/workflow/status'
    },
    UPLOAD: {
      PUBLISH: '/upload-and-publish',
      ZEDGE: '/upload/zedge',
    },
    PROMPTS: {
      TOTAL_ENTRIES: '/prompts/total-entries',
      GET_ALL: '/prompts/get-all-entries',
      SEARCH: '/prompts/search-entries',
      GET_PROMPTS_BY_GROUP: '/prompts/get-prompts', // Ajouter cette ligne
      CREATE_GROUP: '/prompts/create-group'
    },
    DASHBOARD: {
      STATS: '/dashboard/stats',
    },
    BILLING: {
      CHECKOUT: '/stripe/checkout',
      CREDIT_PACK: '/stripe/credits/checkout',
      CHECKOUT_SYNC: '/stripe/checkout/sync',
      SUBSCRIPTION_CHECKOUT: '/stripe/subscription/checkout',
      SUBSCRIPTION_CANCEL: '/stripe/subscription/cancel',
      SUBSCRIPTION_REACTIVATE: '/stripe/subscription/reactivate',
      SUBSCRIPTION_SYNC: '/stripe/subscription/sync',
      STATUS: '/stripe/status',
    },
    USER: {
      PROFILE: '/users/profile',
    },
  },
};
